<template>
  <div class="row">
    <div class="col-20 std-wrapper px-sm-4">
      <div class="row">
        <div class="col-20 col-sm-11">
          <div class="w-100 name">
            {{ campaign.name }}
          </div>
          <div class="w-100 d-flex align-items-center">
            <div
              v-lazy-container="{ selector: 'img' }"
              class="avatar mr-2 my-1"
            >
              <img :data-src="$store.getters['user/getAvatar'](advertiser.user)">
            </div>
            {{ advertiser.user.name }}
          </div>
        </div>
        <div
          class="col-20 col-sm-9 col-b my-4 pl-sm-4 d-flex flex-wrap align-items-center"
          :class="cancelConfirmAsk ? '' : 'justify-content-end'"
        >
          <icon-label
            :label="status.name"
            :icon="status.icon"
          />
          <div
            v-if="(campaign.status === 'inviting' || campaign.status === 'waiting_for_payment') && isAdvertiser"
            class="mt-3 w-100"
          >
            <div v-if="cancelConfirmAsk">
              <div class="mb-3 text-left">
                {{ $t('view-CampaignsDetails.campaign-cancel-ask') }}
              </div>
              <div class="d-flex flex-wrap justify-content-between">
                <std-button
                  type="C"
                  :title="$t('common.button.back')"
                  class="my-2"
                  @click="cancelConfirmAsk = false"
                />
                <std-button
                  type="D"
                  :title="$t('view-CampaignsDetails.button.cancel-campaign')"
                  :loader="buttonLoader"
                  class="my-2"
                  @click="cancelCampaign"
                />
              </div>
            </div>
            <div v-else-if="startConfirmAsk">
              <div class="mb-3 text-left">
                {{ $t('view-CampaignsDetails.campaign-start-ask') }}
              </div>
              <div class="d-flex flex-wrap justify-content-between">
                <std-button
                  type="C"
                  :title="$t('common.button.back')"
                  class="my-2"
                  @click="startConfirmAsk = false"
                />
                <std-button
                  type="C"
                  :title="$t('view-CampaignsDetails.button.start-campaign')"
                  :loader="buttonLoader"
                  class="my-2"
                  @click="startCampaignWithoutFullMembers"
                />
              </div>
            </div>
            <div
              v-else
              class="w-100 d-flex flex-wrap justify-content-between"
            >
              <std-button
                v-if="campaign.status === 'inviting' && minimumOneMember"
                type="C"
                :title="$t('view-CampaignsDetails.button.start-campaign')"
                @click="startConfirmAsk = true"
              />
              <std-button
                v-if="campaign.status === 'waiting_for_payment'"
                type="A"
                direction="left"
                :title="$t('view-CampaignsDetails.button.go-to-payments')"
                :route-link="{name: 'payments'}"
              />
              <span v-else />
              <std-button
                type="D"
                :title="$t('view-CampaignsDetails.button.cancel-campaign')"
                @click="cancelConfirmAsk = true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import campaignStatuses from './campaign_statuses.js'
import memberStatuses from './member_statuses.js'
import iconLabel from '../../../components/IconLabel.vue'

export default {
  components: {
    'icon-label': iconLabel
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    advertiser: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      buttonLoader: false,
      cancelConfirmAsk: false,
      startConfirmAsk: false
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    status () {
      if (this.isAdvertiser) {
        const status = campaignStatuses[this.campaign.status]

        return {
          name: this.$t(`campaign.status.${status.name}`),
          icon: `${this.$publicPath}${status.icon}`
        }
      } else {
        const member = this.campaign.members.filter(member => member.influencer_id === this.$store.state.user.profileTypeData.id)[0]
        const status = memberStatuses[member.status]

        return {
          name: this.$t(`campaignMemberInfluencer.status.${status.name}`),
          icon: `${this.$publicPath}${status.icon}`
        }
      }
    },
    minimumOneMember () {
      if (this.isAdvertiser) {
        const members = this.$store.state.campaignsMembersAdvertiser.members[this.campaign.id]
        return members ? members.filter(member => member.status === 'invite_accepted').length : 0
      } else {
        return this.campaign.members ? this.campaign.members.filter(member => member.status === 'invite_accepted').length : 0
      }
    }
  },
  methods: {
    cancelCampaign () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('campaignsAdvertiser/cancel', this.campaign.id)
        .then(() => {
          this.buttonLoader = false
          this.cancelConfirmAsk = false
          this.$flash.success(this.$t('view-CampaignsDetails.message.cancel-successfull'))
        })
        .catch(() => {
          this.buttonLoader = false
          this.$flash.error(this.$t('view-CampaignsDetails.message.cancel-fail'))
        })
    },
    startCampaignWithoutFullMembers () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('campaignsAdvertiser/startWithoutFullMembers', this.campaign.id)
        .then(() => {
          this.buttonLoader = false
          this.startConfirmAsk = false
          this.$flash.success(this.$t('view-CampaignsDetails.message.start-successfull'))
        })
        .catch(() => {
          this.buttonLoader = false
          this.$flash.error(this.$t('view-CampaignsDetails.message.start-fail'))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .col-b {
    border-left: 1px solid $nh-gray;
  }
  .name {
    font-size: 1.8rem;
    font-weight: 600;
  }
  .avatar img {
    border-radius: 100%;
    max-width: 32px;
  }
</style>
